<div
  class="body"
  [ngClass]="{
    'body--minimal': cardData.cardStyle === 'minimal',
    'body--minimal-alt': cardData.cardStyle === 'minimal-alt',
    'body--halfnhalf': !cardData.cardStyle || cardData.cardStyle === 'halfnhalf',
    'body--halfnhalf-alt': cardData.cardStyle === 'halfnhalf_alt',
    'body--horizontal': cardData.cardStyle === 'horizontal' || showCardBottom,
    'body--float': cardData.cardStyle === 'float',
    'body--article': cardData.cardStyle === 'article',
    'body--small': cardData.size === 'small',
    'body--dark': cardData.darkTheme,
    'body--expanded': showMoreInfo === true,
    'body--horizontal-alt': showCardBottom,
  }"
>
  <section
    class="body__heading body__section body__section--title"
    *ngIf="cardData.body.heading"
    [ngClass]="{ 'body__heading--small': cardData.size === 'small' }"
  >
    <h2
      class="mat-title"
      [ngClass]="{
        'block-with-text': cardData.cardStyle !== 'article' && !showCardBottom,
        'hotel-block-with-text': cardData.type === 'hotel',
      }"
    >
      {{ cardData.body.heading }}
    </h2>
  </section>

  <ng-container *ngIf="cardData.body">
    <!-- badges -->
    <section
      *ngIf="cardData.body.badges?.length"
      class="body__section"
      [ngClass]="{ 'body__section--dark': cardData.darkTheme }"
    >
      <ten-badge *ngFor="let badge of cardData.body.badges" [badge]="badge"></ten-badge>
    </section>

    <!-- ratings -->
    <section
      *ngIf="!!cardData.body.rating && starSvgHtml"
      class="body__section"
      [ngClass]="{ 'body__section--dark': cardData.darkTheme }"
    >
      <ten-card-rating [ratingLevel]="cardData.body.rating" [svgHtml]="starSvgHtml"></ten-card-rating>
    </section>

    <!-- raw body text -->
    <section
      *ngIf="cardData.body.text"
      class="body__text body__section mat-h5"
      [ngClass]="{
        'body__text--small': cardData.size === 'small',
        'body__text--dark': cardData.darkTheme,
      }"
    >
      {{ cardData.body.text }}
    </section>

    <!-- heading -->
    <!-- content-sections -->
    <section
      *ngIf="
        cardData.body.contentSections &&
        !showAmenities &&
        cardData.type !== 'car' &&
        !(cardData.type === 'dining-result' && badgesOnTop)
      "
      class="body__section body__section--content"
      [ngClass]="{ 'body__section--dark': cardData.darkTheme }"
    >
      <div *ngFor="let section of cardData.body.contentSections" class="body__content-section">
        <ul class="body__content-list" *ngIf="section.content.length > 0 && section.content[0] !== ''">
          <ng-container *ngFor="let content of section.content | slice: 0 : 3">
            <li *ngIf="content" class="mat-caption">
              <div
                class="mat-body-1 body__content-item"
                [class.mb-0]="cardData.type === 'car'"
                [class.body__mobileContent]="showCardBottom"
              >
                {{ cardData.type === 'car' ? (content | titlecase) : content }}
              </div>
            </li>
          </ng-container>
        </ul>
      </div>
    </section>
    <ng-content select="carBody"></ng-content>

    <!-- bookings -->
    <section *ngIf="cardData.body.booking?.description && !showMoreInfo" class="body__booking body__section">
      <div
        *ngIf="cardData.body.booking?.description"
        [ngClass]="{
          'body__bookingdelimiter': cardData.body.booking.time || cardData.body.booking.date,
          'body__section--dark': cardData.darkTheme,
        }"
        class="mat-h4 body__booking-description"
        [innerHTML]="bookingDescription"
      >
        {{ bookingDescription }}
      </div>
    </section>

    <!-- status indicators -->
    <section
      *ngIf="cardData.body.status && !showMoreInfo"
      class="body__status body__section"
      [ngClass]="{ 'body__status--healthy': cardData.body.status.healthy }"
    >
      <span class="mat-h4">{{
        cardData.body.status.descriptionKey
          ? (cardData.body.status.descriptionKey | translate)
          : cardData.body.status.description
      }}</span>
    </section>

    <!-- dates available -->
    <section *ngIf="cardData.body.firstDateAvailable">
      <div class="body__available-from" [ngClass]="{ 'body__text--dark': cardData.darkTheme }">
        <span *ngIf="cardData.body.availableDatesCount > 1" class="prefix">From</span>
        {{ cardData.body.firstDateAvailable | customDatePipe: 'Do MMMM YYYY' }}
      </div>
    </section>

    <!-- tags -->
    <ng-container *ngIf="!(cardData.type === 'dining-result' && badgesOnTop)">
      <div class="body__tagcontainer__wrapper" *ngIf="cardData.type === 'member-benefit'">
        <section class="body__tagcontainer date">
          <div id="expiring-soon-offer" class="body__date_incentive expiring-soon" *ngIf="cardData.body.expiringSoon">
            {{ 'MemberBenefitsSearchComponent:ExpiringSoon' | translate }}
          </div>
          <div
            id="new-offer"
            class="body__date_incentive new-offer"
            *ngIf="cardData.body.isNewOffer && !cardData.body.expiringSoon"
          >
            {{ 'MemberBenefitsSearchComponent:NewOffer' | translate }}
          </div>
        </section>
        <section
          class="body__tagcontainer body__section tags"
          *ngIf="cardData.body.tags && cardData.body.tags?.length && !showMoreInfo"
        >
          <div class="body__separator"></div>
          <ul class="body__taglist">
            <li class="mat-body-1 random-tag" *ngFor="let tag of cardData.body.randomTwoTags">
              {{ tag | translate }}
            </li>
          </ul>
        </section>
      </div>
      <div
        class="body__tagcontainer__wrapper"
        *ngIf="cardData.type === 'member-event' || (cardData.type === 'dining-result' && !asyncPageLoad)"
      >
        <section
          class="body__tagcontainer body__section tags"
          *ngIf="cardData.body.tags && cardData.body.tags?.length && !showMoreInfo"
        >
          <div class="body__separator"></div>
          <ul class="body__taglist">
            <li class="mat-body-1 random-tag" *ngFor="let tag of cardData.body.tags">
              {{ tag.text | translate }}
            </li>
          </ul>
        </section>
      </div>
    </ng-container>

    <div class="body__tagcontainer__wrapper" *ngIf="cardData.type === 'dining-result' && badgesOnTop && !asyncPageLoad">
      <section
        class="body__tagcontainer body__section"
        *ngIf="
          cardData.body.contentSections[0]?.content && cardData.body.contentSections[0]?.content.length && !showMoreInfo
        "
      >
        <div class="body__separator"></div>
        <ul class="body__taglist">
          <li class="mat-body-1" *ngFor="let tag of cardData.body.contentSections[0]?.content | slice: 0 : 3">
            {{ tag | translate }}
          </li>
        </ul>
      </section>
    </div>

    <section
      class="body__value-prop-container body__section body__section--value-prop mat-body-1"
      *ngIf="cardData.body.valueProposition"
    >
      <ng-content select="ten-card-value-proposition"></ng-content>
    </section>
    <section
      [ngClass]="{
        'body__section body__section--booking-cta': cardData?.cardStyle !== 'horizontal',
      }"
      *ngIf="asyncPageLoad && !showCardBottom"
    >
      <ten-card-booking-cta [availabilityStatus]="cardData?.availabilityStatus"></ten-card-booking-cta>
    </section>

    <!--price container-->
    <section class="body__section body__section--price" *ngIf="cardData.body.price?.price">
      <div class="price-box">
        <span
          [ngStyle]="{ order: currency !== currencyEnum.JPY ? '' : 3 }"
          [translate]="'TravelCarSearchResult:PricePrefix'"
          >From</span
        >
        <span
          class="mat-title price-box__price"
          [ngClass]="{ 'price-box__price--jpy': currency === currencyEnum.JPY }"
          >{{
            cardData.body.price.price | currency: cardData.body.price.currency : 'symbol' | customCurrencyPipe
          }}</span
        >
      </div>
    </section>

    <div *ngIf="cardData.payWithPointsEnabled" class="pay-with-points">
      <div class="icon"></div>
      <span>{{ 'PayWithPoints:PayWithPoints' | translate }}</span>
    </div>

    <p class="body__seeMoreAmenities mt-auto" *ngIf="showAmenities && !showMoreInfo">
      <a href (accessibleClick)="onCardClicked($event)">{{ 'ButtonViewHotel' | translate }}</a>
    </p>

    <button
      mat-flat-button
      class="body__seeBenefits mt-auto"
      color="secondary"
      *ngIf="showBenefits"
      (accessibleClick)="onCardClicked($event)"
    >
      {{ 'PreLoginCTA:SeeBenefit' | translate }}
    </button>

    <div *ngIf="showAmenities" class="body__seeMore">
      <a href class="close-icon" (click)="seeMore($event); $event.stopPropagation()" aria-label="close">
        <mat-icon class="body__seeMoreClose">close</mat-icon>
      </a>
      <ng-container *ngIf="cardData.body.contentSections && isAmenities">
        <section
          class="body__section body__section--content body__section--amenities"
          [ngClass]="{ 'body__section--dark': cardData.darkTheme }"
        >
          <h3 [translate]="'SideFilterComponent:TitleAmenities'"></h3>
          <div *ngFor="let section of cardData.body.contentSections" class="body__content-section">
            <ul class="body__content-list amenities">
              <li *ngFor="let content of section.content | slice: 0 : 3" class="mat-caption">
                <div class="body__content-item" [title]="content">{{ content }}</div>
              </li>
            </ul>
          </div>
        </section>
      </ng-container>

      <div class="row">
        <div class="col-12 pb-0">
          <ng-container *ngIf="cardData.body.showAmenityLearnMore">
            <h3>{{ (customVariablesService.variables | async)?.hotel_subheader }}</h3>

            <a
              class="body__learnMoreTC"
              (accessibleClick)="openModal(); $event.stopPropagation(); $event.preventDefault()"
            >
              {{ 'PopupInfoBoxComponent:LearnMore' | translate }}
            </a>

            <hr class="mt-2" />
          </ng-container>

          <p class="body__seeMoreAmenities">
            <a href (accessibleClick)="onCardClicked($event)">{{ 'ButtonViewHotel' | translate }}</a>
          </p>
        </div>

        <div class="col-2 pb-0">
          <!-- place for icons -->
        </div>
      </div>
    </div>
  </ng-container>
  <a href="" id="hidden-anchor-link" tabindex="-1" aria-hidden="true" class="hidden-anchor-element"></a>
</div>
